import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login.service';

@Injectable({
  providedIn: 'root',
})
export class KmAccessDeniedGuard {
  private router = inject(Router);
  loginService = inject(LoginService);

  canActivate(): boolean {
    // make sure user's AccessDeniedServices is not including "KM"
    if (!this.loginService.hasAccessToKiwimonster()) {
      if (this.loginService.getPlatformSetting() === 3) {
        this.router.navigate(['/dashboard']);
      } else {
        let dashboardUrl = this.loginService.platformDashboard(this.loginService.getPlatformSetting());
        this.router.navigate([`/${dashboardUrl}`]);
      }
      return false;
    }
    return true;
  }
}
